import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ButtonWrapper } from './styles';
import IconFont from '../shared/IconFont';

class DateTimeButton extends Component {
  constructor() {
    super();
    this.state = ({
    });
  }
  render() {
    const { onClick, color } = this.props;
    return (
      <ButtonWrapper
        onClick={onClick}
      >
        <IconFont
          className="icon-matchcenter-calendar"
          color={color}
          font={28}
          marginLeft={0.3}
          weight="bold"
          withCursor
        />
        <IconFont
          className="icon-matchcenter-down-arrow"
          color={color}
          font={10}
          marginLeft={0.5}
          marginTop={0.6}
          weight="bold"
          withCursor
        />
      </ButtonWrapper>
    );
  }
}

DateTimeButton.propTypes = {
  onClick: PropTypes.func,
  color: PropTypes.string,
};

export default DateTimeButton;



// WEBPACK FOOTER //
// ./src/components/DateTimeButton/index.js